<template>
  <div class="setting-content--section">
    <TitleBar v-if="currentUser.is_accountant">
      <template v-slot:title>
        <h1>{{ $gettext('Change your password') }}</h1>
      </template>
    </TitleBar>
    <div class="content">
      <div style="max-width: 1024px; width: 100%;">
        <div v-if="currentUser.is_accountant" style="margin-bottom: 2rem;">
          <p class="branding-description-text">
            {{ $gettext('Please confirm your current password and set a new one to continue.') }}
          </p>
        </div>
        <b-form @submit.prevent="onSubmit">
          <b-form-group
            id="input-group-1"
            label-cols-sm="3"
            label-align-sm="right"
            content-cols-md="5"
            label-class="gk-label-margin"
            :label="$gettext('Current password*')"
            label-for="input-1"
          >
            <b-form-input data-analytics-click v-model="form.old_password" type="password" id="input-1"></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-2"
            label-cols-sm="3"
            label-align-sm="right"
            content-cols-md="5"
            label-class="gk-label-margin"
            :label="$gettext('New password*')"
            label-for="input-2"
          >
            <b-form-input data-analytics-click v-model="form.new_password1" type="password" id="input-2"></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-3"
            label-cols-sm="3"
            label-align-sm="right"
            content-cols-md="5"
            label-class="gk-label-margin"
            :label="$gettext('Confirm new password*')"
            label-for="input-3"
          >
            <b-form-input data-analytics-click v-model="form.new_password2" type="password" id="input-3"></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-4"
            class="button-group"
            label-cols-sm="3"
            label-align-sm="right"
            content-cols-md="5"
            label-class="gk-label-margin"
            label=""
            label-for="input-4"
          >
            <GekkoButton
              :text="$gettext('Change password')"
              type="submit"
              class="position-relative"
              :loading="isWaitingForResponse"
            />
          </b-form-group>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import UserService from '@/store/services/user.service.js'
import GekkoButton from '@/components/GekkoButton'
import TitleBar from '@/components/TitleBar'

// mixins
import settingsPageSetup from '@/mixins/settingsPageSetup'

export default {
  name: 'ChangePassword',
  components: {
    GekkoButton,
    TitleBar
  },
  mixins: [settingsPageSetup],
  data() {
    return {
      pageSettings: {
        title: this.$gettext('Change your password'),
        showCompanyPicker: false,
      },
      form: {
        old_password: '',
        new_password1: '',
        new_password2: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      isWaitingForResponse: 'main/isWaitingForResponse',
      currentUser: 'main/getCurrentUser'
    }),
  },
  methods: {
    ...mapMutations({
      setWaitingForResponse: 'main/SET_WAITING_FOR_RESPONSE',
    }),
    onSubmit(event) {
      event.preventDefault()
      if (this.form.old_password === '' || this.form.new_password1 === '' || this.form.new_password2 === '') {
        this.$store.commit('setAlert', {
          title: this.$gettext('Warning'),
          text: this.$gettext('Password inputs cannot be empty.'),
          variant: 'error',
          duration: 4,
        })
        return
      }
      this.setWaitingForResponse(true)
      UserService.changePassword(this.form)
        .then((response) => {
          console.log(response.data.error_code)
          console.log(response)
          console.log(response.data)

          if (response.data.error_code === 'wrong_password') {
            this.$store.commit('setAlert', {
              title: this.$gettext('Warning'),
              text: this.$gettext('Incorrect old password.'),
              variant: 'danger',
              duration: 4,
            })
          } else if (response.data.error_code === 'incorrect_length') {
            this.$store.commit('setAlert', {
              title: this.$gettext('Warning'),
              text: this.$gettext('The password should be at least 6 characters'),
              variant: 'danger',
              duration: 4,
            })
            return
          } else if (response.data.error_code === 'password_mismatch') {
            this.$store.commit('setAlert', {
              title: this.$gettext('Warning'),
              text: this.$gettext('Passwords do not match'),
              variant: 'danger',
              duration: 4,
            })
            return
          } else if (response.data.message === 'success') {
            this.$store.commit('setAlert', {
              title: this.$gettext('Success'),
              text: this.$gettext('Password changed successfully'),
              variant: 'success',
              duration: 4,
            })
            return
          }
        })
        .finally(() => {
          this.setWaitingForResponse(false)
        })
    },
  },
  beforeRouteLeave(to, from, next) {
    next()
  },
}
</script>
<style>
.float-alert-top {
  right: 40%;
  position: fixed !important;
  top: 50px;
  margin: auto;
  z-index: 1000;
  font-size: 24px;
}
</style>